<script setup>
import { computed } from 'vue'
import { getPrice, showDurationUnit } from '@utils'
import { ProfilePicture } from '@components'

import { useAppointments } from '@store/appointments'
const $appointments = useAppointments()

import { useSettings } from '@store/settings'
const $settings = useSettings()

import { useCustomizer } from '@store/customizer'
const $customizer = useCustomizer()

const emit = defineEmits(['select'])

const props = defineProps({
    service: {
        type: Object,
        required: true
    }
})

const serviceLayout = computed(() => {
    return $settings.customizer.service.layout_type
})

const serviceImageClass = computed(() => {
    switch (serviceLayout.value) {
        case 'row01':
            return `service-image-row ${$customizer.isRounded ? '' : '!rounded-none'} ${$settings.customizer.service.layout_type == 'row01' ? '!h-[60px]' : '!h-[66px]'}`
        case 'grid01':
            return `service-image-grid ${$customizer.isRounded ? '' : '!rounded-none'} ${$settings.customizer.service.layout_type == 'row01' ? '!h-[60px]' : '!h-[66px]'}`
        default:
            return `service-image-row ${$customizer.isRounded ? '' : '!rounded-none'} ${$settings.customizer.service.layout_type == 'row01' ? '!h-[60px]' : '!h-[66px]'}`
    }
})

const serviceInfoClass = computed(() => {
    switch (serviceLayout.value) {
        case 'row01':
            return 'service-info-row'
        case 'grid01':
            return 'service-info-grid'
        default:
            return 'service-info-row'
    }
})

const serviceTitleClass = computed(() => {
    switch (serviceLayout.value) {
        case 'row01':
            return `service-title-row ${$settings.isWidget ? '!max-w-[125px]' : ''}`
        case 'grid01':
            return 'service-title-grid'
        default:
            return `service-title-row ${$settings.isWidget ? '!max-w-[125px]' : ''}`
    }
})

const serviceDurationClass = computed(() => {
    switch (serviceLayout.value) {
        case 'row01':
            return 'service-duration-row'
        case 'grid01':
            return 'service-duration-grid'
        default:
            return 'service-duration-row'
    }
})

</script>

<template>
<div :title="props.service?.name || '-'" @click.prevent="emit('select', props.service)" class="service-item"
    :class="{ 'active': $appointments.selectedService.service_id === props.service.service_id }"
    :style="`border-radius: ${$customizer.isRounded ? '' : '0px'} !important;`">
    <div class="content-wrapper">
        <ProfilePicture v-if="$settings.customizer.service.show_image" :name="props.service.name"
            :img="props.service.thumbnail_image_url" :bgColor="props.service.color" :textClass="serviceImageClass"
            :imgClass="serviceImageClass" />

        <div
            :class="serviceInfoClass, { 'justify-between': $settings.customizer.service.show_price && props.service.price_type != 'none' && serviceLayout == 'grid01' }">
            <div :class="serviceTitleClass" :style="$customizer.subtitleStyle">{{ props.service?.name || '-' }}</div>
            <div :class="serviceDurationClass, { 'mt-[3px]': (!$settings.customizer.service.show_price || props.service.price_type != 'none') && serviceLayout == 'grid01' }"
                :style="$customizer.subtitleStyle"
                v-if="$settings.customizer.service.show_hours && serviceLayout == 'grid01'">{{
                    showDurationUnit(props.service.duration, props.service.duration_unit) }}</div>
            <div class="service-price"
                v-if="$settings.customizer.service.show_price && props.service.price_type != 'none'">{{
                    props.service.price_type == 'free' ? "Free" : getPrice(props.service.price) }}</div>
        </div>
    </div>
    <div :class="serviceDurationClass" :style="$customizer.subtitleStyle"
        v-if="$settings.customizer.service.show_hours && serviceLayout == 'row01'">{{
            showDurationUnit(props.service.duration, props.service.duration_unit) }}</div>
</div>
</template>
